import { lazy, Suspense } from 'react';

const ForgotPasswordForm = lazy(() =>
  import('@repo/ui/components/containers/login/forgot-password-form').then((mod) => ({ default: mod.default })),
);

export default function ForgotPasswordPage() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
      <ForgotPasswordForm />
    </Suspense>
  );
}
